import { useCookies } from 'react-cookie';
import { LocationCookie } from '../utils/constants';
import * as locationParser from '../utils/locationParser';
import { useMemo, useCallback } from 'react';
import { updateZipcodeCookies } from '../utils/cookieUpdater';
export default () => {
  const [cookies, setCookie] = useCookies([LocationCookie]);
  const locationCookieValue = cookies[LocationCookie];
  const globapZipInfo = useMemo(() => locationParser.decode(locationCookieValue), [locationCookieValue]);
  const updateGlobalZip = useCallback(newGlobalZipInfo => {
    updateZipcodeCookies(newGlobalZipInfo, setCookie);
  }, [setCookie]);
  return {
    globalZip: globapZipInfo.zip,
    userInputZip: globapZipInfo.zip,
    globalZipInfo: globapZipInfo,
    updateGlobalZip
  };
};